export const helpCenterLink =
  'https://support.devinco.com/hc/en-us/categories/360000019403-ViaTracks';
export const releaseNotesLink =
  'https://support.devinco.com/hc/en-us/sections/23328700461597-ViaTracks-Web';
